import { publicConfig, RequestHeader, serverConfig } from '../../services';
import { RequestClient } from '../../services/request/request.service';
import {
  certificateErrorAdapter,
  courseCertificateResponseAdapter,
  courseCertificatesResponseAdapter,
} from './certificate.adapter';
import {
  CertificateApiResponseModel,
  CertificateModel,
  CertificatesApiResponseModel,
} from './certificate.model';

export class CreateCertificateClient extends RequestClient<
  { student_course_id: string },
  CertificateApiResponseModel,
  CertificateModel
> {
  protected adapter = courseCertificateResponseAdapter;
  // @ts-ignore
  protected errorAdapter = certificateErrorAdapter;
  protected path = `certificates-api/v1/me/certificates`;
  protected requestParameters: { student_course_id: string };

  constructor(studentCourseId: string) {
    super(publicConfig.API_GATEWAY_URL);
    this.requestParameters = {
      student_course_id: studentCourseId,
    };
  }
}

export class CertificatesClient extends RequestClient<
  null,
  CertificatesApiResponseModel,
  CertificateModel[]
> {
  protected adapter = courseCertificatesResponseAdapter;
  protected path = `certificates-api/v1/me/certificates`;
  protected requestParameters: null;

  constructor(requestHeaders?: RequestHeader) {
    super(
      publicConfig.API_GATEWAY_URL,
      serverConfig?.PRIVATE_API_GATEWAY_INTERNAL_URL,
      requestHeaders
    );
    this.requestParameters = null;
  }
}
